import { useState, useEffect, useCallback } from "react";
import { db } from "../db";
import { Spinner, Stage, StageTabs } from "../components/primitives";
import { FluxoMedClientes }        from "./fluxomed/FluxoMedClientes";
import { FluxoMedClienteDetail }   from "./fluxomed/FluxoMedClienteDetail";
import { FluxoMedDashboard }       from "./fluxomed/FluxoMedDashboard";
import { FluxoMedGuia }            from "./fluxomed/FluxoMedGuia";
import { FluxoMedHomologacaoView } from "./fluxomed/FluxoMedHomologacaoView";
import { FluxoMedCentral }         from "./fluxomed/FluxoMedCentral";

const MODULE_TABS = [
  { id: "central",     label: "Central"          },
  { id: "dashboard",   label: "Dashboard"        },
  { id: "clientes",    label: "Clientes"         },
  { id: "homologacao", label: "Homologação"      },
  { id: "guia",        label: "Guia do Produto"  },
];

export function FluxoMedView() {
  const [page, setPage]           = useState("central");
  const [clienteId, setClienteId] = useState(null);
  const [clientes, setClientes]   = useState([]);
  const [loading, setLoading]     = useState(true);

  const loadClientes = useCallback(async () => {
    try {
      const data = await db("fluxomed_clientes", "GET", null, "?order=created_at.desc");
      setClientes(data || []);
    } catch (e) {
      console.error("FluxoMed: erro ao carregar clientes:", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadClientes(); }, [loadClientes]);

  if (loading) {
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", flexDirection: "column", gap: 12 }}>
        <Spinner size={24} />
        <span style={{ fontSize: 13, color: "var(--muted)" }}>Carregando FluxoMed...</span>
      </div>
    );
  }

  // Detalhe do cliente ocupa a tela inteira — sem nav de módulo
  if (clienteId) {
    return (
      <FluxoMedClienteDetail
        clienteId={clienteId}
        onBack={() => setClienteId(null)}
        onDeleted={() => { loadClientes(); setClienteId(null); }}
        onSaved={loadClientes}
      />
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100%" }}>

      {/* ── Palco do módulo ──────────────────────────────────── */}
      <div style={{ padding: "24px 28px 0", flexShrink: 0 }} className="fm-stage-wrap">
        <Stage
          path={`fluxomed/${page}`}
          title="FluxoMed"
          hl={(MODULE_TABS.find((t) => t.id === page) || MODULE_TABS[0]).label}
          lead="Bot de pré-agendamento no WhatsApp"
          tabs={<StageTabs label="Seções do FluxoMed" items={MODULE_TABS} active={page} onChange={setPage} />}
        />
      </div>

      {/* ── Conteúdo da página ───────────────────────────────── */}
      <div style={{ flex: 1 }}>
        {page === "central"     && (
          <FluxoMedCentral onOpen={(id) => setClienteId(id)} />
        )}
        {page === "dashboard"   && (
          <FluxoMedDashboard clientes={clientes} onOpen={(id) => setClienteId(id)} />
        )}
        {page === "clientes"    && (
          <FluxoMedClientes
            clientes={clientes}
            onOpen={(id) => setClienteId(id)}
            onCreated={(id) => { loadClientes(); setClienteId(id); }}
          />
        )}
        {page === "homologacao" && (
          <FluxoMedHomologacaoView clientes={clientes} onOpen={(id) => setClienteId(id)} />
        )}
        {page === "guia"        && <FluxoMedGuia />}
      </div>
    </div>
  );
}
